import React from 'react';
import { motion } from 'framer-motion';

const TrustSection = ({ data }) => {
    // Agar data nahi hai to render mat karo
    if (!data || data.length === 0) return null;

    return (
        <section className="relative w-full bg-white py-16 lg:py-24 overflow-hidden">
            {/* SVG Background Map */}
            <motion.div
                animate={{ x: [0, 20, 0], y: [0, -15, 0] }}
                transition={{ duration: 6, repeat: Infinity, ease: "easeInOut" }}
                className="absolute top-[-50px] right-[-100px] opacity-40 pointer-events-none"
            >
                <svg width="600" height="500" viewBox="0 0 600 500" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M150 -50C250 150 400 -50 500 150C600 -50 750 150 850 -50" stroke="#CBD5E1" strokeWidth="1" />
                    <path d="M150 -30C250 170 400 -30 500 170C600 -30 750 170 850 -30" stroke="#CBD5E1" strokeWidth="1" />
                    <path d="M150 -10C250 190 400 -10 500 190C600 -10 750 190 850 -10" stroke="#CBD5E1" strokeWidth="1" />
                    <path d="M150 10C250 210 400 10 500 210C600 10 750 210 850 10" stroke="#CBD5E1" strokeWidth="1" />
                    <path d="M150 30C250 230 400 30 500 230C600 30 750 230 850 30" stroke="#CBD5E1" strokeWidth="1" />
                    <path d="M150 50C250 250 400 50 500 250C600 50 750 250 850 50" stroke="#CBD5E1" strokeWidth="1" />
                </svg>
            </motion.div>

            <div className="max-w-[1440px] mx-auto px-6 lg:px-[80px] relative z-10">
                <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-10">
                    {/* Dynamic Map Start */}
                    {data.map((block, index) => (
                        <motion.div
                            key={index}
                            initial={{ opacity: 0, y: 40 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true }}
                            transition={{ duration: 0.8, ease: "easeOut", delay: index * 0.2 }}
                            className="bg-[#F0F0F0] p-[20px] md:p-[30px] lg:p-[40px] flex flex-col min-h-[420px]"
                        >
                            <h3 className="text-[#01386A]  text-[20px] md:text-[30px] font-[600] font-sora leading-[1.4] pr-4">
                                {block.heading}
                            </h3>
                            <p className="text-[#49577A] text-[14px] md:text-[16px] leading-[24px] font-[500] font-graphik mt-auto">
                                {block.description}
                            </p>
                        </motion.div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default TrustSection;